/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path ui/hooks
 * @description Query Builder helper hook
 */
import React from "react";
import { useLocation } from "react-router-dom";
function useQueryParams() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}
export default useQueryParams;
